import { Body, Heading, Sheet } from '@hover/blueprint';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router';

import { Button } from 'src/shared/components';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';
import { Route as Routes } from 'src/shared/route';

import {
  useActiveOriginalImage,
  useDeleteClickHandler,
  useHomeownerAppContext,
} from '../../hooks';
import { isSampleOriginal } from '../../types';

interface DeleteConfirmationProps {
  onClose: () => void;
}

const DeleteConfirmation = ({ onClose }: DeleteConfirmationProps) => {
  const { setCurrentMenu, trackingData } = useHomeownerAppContext();
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);
  const history = useHistory();

  const { image } = useActiveOriginalImage();

  const isSampleImage = isSampleOriginal(image);
  const aiOriginalImageId = isSampleImage ? undefined : image?.id;

  const [handleDeleteClick, deleteResult] =
    useDeleteClickHandler(aiOriginalImageId);

  useEffect(() => {
    if (deleteResult.data || deleteResult.error) {
      setCurrentMenu(null);
      history.push(Routes.HOMEOWNER_APP_HOME.path);
    }
  }, [deleteResult.data, deleteResult.error, history, setCurrentMenu]);

  return (
    <Sheet.Contents contentKey="delete-confirmation">
      <Heading width="100%">{t('uploadedImage.delete.header')}</Heading>
      <Body pb={500}>{t('uploadedImage.delete.confirmationText')}</Body>
      <Button
        backgroundColor="danger600"
        onClick={() => {
          handleDeleteClick();
          setCurrentMenu(null);
          history.push(Routes.HOMEOWNER_APP_HOME.path);
        }}
        optionalTrackingProperties={{
          ...trackingData,
          button_location: 'original-image-more-actions-delete-confirmation',
          track_id: 'delete-original-image-confirm',
          ai_original_image_id: aiOriginalImageId,
        }}
        width="100%"
      >
        {t('uploadedImage.delete.delete')}
      </Button>
      <Button
        mt={200}
        onClick={() => {
          onClose();
        }}
        optionalTrackingProperties={{
          ...trackingData,
          button_location: 'original-image-more-actions-delete-confirmation',
          track_id: 'delete-original-image-cancel',
          ai_original_image_id: aiOriginalImageId,
        }}
        variant="ghost"
        width="100%"
      >
        {t('uploadedImage.delete.cancel')}
      </Button>
    </Sheet.Contents>
  );
};

export { DeleteConfirmation };
